import CrudRequest from '@rootCommon/services/crud-request';
import { PERMISSIONS } from '@rootCommon/constants/end-points';
import { PermissionTemplate } from '@rootCommon/types/permission';
import { ADMIN } from '@rootCommon/constants/common';

const PERMISSIONS_TEMPLATES_ADMIN = `${PERMISSIONS}/templates/${ADMIN}`;

class PermissionTemplatesService extends CrudRequest<PermissionTemplate, PermissionTemplate> {
  constructor() {
    super(PERMISSIONS_TEMPLATES_ADMIN);
  }

  getList = async (): Promise<PermissionTemplate[]> => {
    const res = await CrudRequest.get<PermissionTemplate[]>(PERMISSIONS_TEMPLATES_ADMIN);

    return res.data;
  };
}

export default new PermissionTemplatesService();
